import { SotiAssistMessageType } from "app/modules/remote-control-ng/definitions";
import { MemoryBuffer } from "../../utils/memoryBuffer";
import { BaseMessage } from "../baseMessage";
import { hd } from "@nx-fe/services";

export interface IDownloadInfo {
    attachmentLink: string;
    fileName: string;
}

export type IDeviceCaptureActivity = hd.IDeviceCaptureActivity;

/** SAC_DEVICE_LOGS_DOWNLOAD_READY SotiAssistMessageType */
export class DeviceLogsDownloadReadyMessage extends BaseMessage {
    public response: IDownloadInfo = <IDownloadInfo>{};

    public deserializeBody(buffer: MemoryBuffer): void {
        this.response.attachmentLink = buffer.readString();
        this.response.fileName = buffer.readString()
    }
}

/** SAC_DEVICE_CAPTURE_ACTIVITY_CREATED SotiAssistMessageType */
export class DeviceCaptureActivityCreatedMessage extends BaseMessage {
    public response: IDeviceCaptureActivity = <IDeviceCaptureActivity>{};

    public deserializeBody(buffer: MemoryBuffer): void {
        this.response.activityId = buffer.readInt32BE();
        this.response.captureType = buffer.readInt32BE();
    }
}

/** SAC_DEVICE_LOGS_REQUEST_COMPLETED SotiAssistMessageType */
export class DeviceLogsRequestCompletedMessage extends BaseMessage {
    public response: IDeviceCaptureActivity = <IDeviceCaptureActivity>{};

    public deserializeBody(buffer: MemoryBuffer): void {
        // Currently Agent could not report adb logs based on request Id so we should only allow 1 request at a time
        // var requestId = header.requestId;

        this.response.activityId = buffer.readInt32BE();
        this.response.captureType = buffer.readInt32BE();
    }
}

/** SAC_DEVICE_LOGS_REQUEST_CANCELED SotiAssistMessageType */
export class DeviceLogsRequestCancelled extends BaseMessage{
    public response: IDeviceCaptureActivity = <IDeviceCaptureActivity>{};
    constructor() {
        super();
        this.header.command = SotiAssistMessageType.SAC_DEVICE_LOGS_REQUEST_CANCELED;
    }

    // message has no custom body content, no serializeBody() override
}
